import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system";
import { useToken } from "@chakra-ui/react";
import { HeadingMain, HeadingMainCorail, HeadingBottom, HeadingBottomCorail, SlopeMdMain, SlopeMdMainCorail, SlopeMdBottom, SlopeMdBottomCorail, SlopeSmMain, SlopeSmMainCorail, } from "../../../../assets/icons/static/BackgroundSVGs";
import { BackgroundVariant } from "../Background.types";
import { getBackgroundBottomSvgFromColorTheme, getBackgroundMainSvgFromColorTheme, } from "../Background.helpers";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "container",
    "front",
    "back",
    "columnOne",
    "columnTwo",
    "rowOne",
    "rowTwo",
]);
const baseStyle = definePartsStyle(({ width, height }) => ({
    container: {
        height: `${height}`,
        width: `${width}`,
        position: "relative",
    },
    back: {
        height: "100%",
        width: "100%",
        display: "flex",
        position: "absolute",
        flexFlow: "row-reverse",
    },
    front: {
        position: "relative",
        width: "100%",
        height: "100%",
        zIndex: 1,
    },
    columnOne: {
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        flexGrow: 1,
        flexShrink: 0,
    },
    columnTwo: {
        height: "100%",
        width: "100%",
        flexGrow: 0,
        flexShrink: 1,
    },
    rowOne: {
        height: "100%",
        width: "100%",
        backgroundRepeat: "no-repeat",
        margin: 0,
        padding: 0,
    },
    rowTwo: {
        flex: 1,
        height: "100%",
        width: "100%",
        backgroundRepeat: "no repeat",
        backgroundSize: "auto",
    },
}));
const variants = {
    [BackgroundVariant.CHEVRON]: definePartsStyle(({ backgroundColor, colorTheme, reverse }) => ({
        back: {
            flexFlow: reverse ? "row-reverse" : "row",
        },
        columnOne: Object.assign({ flexFlow: "column", maxWidth: "396px" }, (reverse ? {} : { transform: "scalex(-1)" })),
        columnTwo: {
            backgroundColor,
        },
        rowOne: {
            maxHeight: "678px",
            maxWidth: "396px",
            background: `url('data:image/svg+xml, ${getBackgroundMainSvgFromColorTheme(colorTheme)}') ${useToken("colors", backgroundColor)} no-repeat`,
            backgroundPosition: "top right",
            backgroundSize: "396px 678px",
        },
        rowTwo: {
            backgroundColor: "semantic.foreground.primary",
            maxWidth: "396px",
            background: `url('data:image/svg+xml, ${getBackgroundBottomSvgFromColorTheme(colorTheme)}') ${useToken("colors", backgroundColor)}`,
            backgroundPosition: "top right",
        },
    })),
    [BackgroundVariant.SLOPESM]: definePartsStyle(({ backgroundColor, colorTheme }) => ({
        columnOne: {
            flexFlow: "column-reverse",
            maxWidth: "360px",
        },
        columnTwo: {
            backgroundColor,
        },
        rowOne: {
            maxHeight: "640px",
            maxWidth: "360px",
            background: `url('data:image/svg+xml,${colorTheme === "corail" ? SlopeSmMainCorail : SlopeSmMain}') ${useToken("colors", backgroundColor)} no-repeat`,
            backgroundPosition: "bottom right",
            backgroundSize: "360px 402px",
        },
        rowTwo: {
            backgroundColor,
            maxWidth: "360px",
            backgroundImage: "none",
        },
    })),
    [BackgroundVariant.SLOPEMD]: definePartsStyle(({ backgroundColor, colorTheme }) => ({
        columnOne: {
            flexFlow: "column",
            maxWidth: "720px",
        },
        columnTwo: {
            backgroundColor,
        },
        rowOne: {
            maxHeight: "1024px",
            maxWidth: "720px",
            background: `url('data:image/svg+xml,${colorTheme === "corail" ? SlopeMdMainCorail : SlopeMdMain}') ${useToken("colors", backgroundColor)} no-repeat`,
            backgroundPosition: "bottom right",
            backgroundSize: "720px 787px",
        },
        rowTwo: {
            maxWidth: "720px",
            background: `url('data:image/svg+xml,${colorTheme === "corail" ? SlopeMdBottomCorail : SlopeMdBottom}') ${useToken("colors", backgroundColor)}`,
            backgroundPosition: "top right",
        },
    })),
    [BackgroundVariant.HEADING]: definePartsStyle(({ backgroundColor, colorTheme }) => ({
        columnOne: {
            flexFlow: "column",
            maxWidth: "219px",
        },
        columnTwo: {
            backgroundColor,
        },
        rowOne: {
            maxHeight: "324px",
            maxWidth: "219px",
            background: `url('data:image/svg+xml,${colorTheme === "corail" ? HeadingMainCorail : HeadingMain}') ${useToken("colors", backgroundColor)} no-repeat`,
            backgroundPosition: "top right",
            backgroundSize: "219px 324px",
        },
        rowTwo: {
            maxWidth: "219px",
            background: `url('data:image/svg+xml,${colorTheme === "corail" ? HeadingBottomCorail : HeadingBottom}') ${useToken("colors", backgroundColor)}`,
            backgroundPosition: "top right",
        },
    })),
};
const BackgroundTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    defaultProps: {
        variant: BackgroundVariant.CHEVRON,
    },
});
export default BackgroundTheme;
//# sourceMappingURL=Background.default.js.map